export default {
  namespaced: true,
  state: {
    idCustomer: window.localStorage.getItem('idCustomer') ? window.localStorage.getItem('idCustomer') : null,
    loginCustomer: window.localStorage.getItem('loginCustomer') ? window.localStorage.getItem('loginCustomer') : null,
    nomeCompany: window.localStorage.getItem('nomeCompany') ? window.localStorage.getItem('nomeCompany') : null,
    emailCompany: window.localStorage.getItem('emailCompany') ? window.localStorage.getItem('emailCompany') : null,
    tokenCustomer: window.localStorage.getItem('tokenCustomer') ? window.localStorage.getItem('tokenCustomer') : null,
    companyCustomer: window.localStorage.getItem('companyCustomer') ? window.localStorage.getItem('companyCustomer') : null,
    companyKeyCustomer: window.localStorage.getItem('companyKeyCustomer') ? window.localStorage.getItem('companyKeyCustomer') : null
  },
  getters: {
    getId: state => {
      return state.idCustomer
    },
    getToken: state => {
      return state.tokenCustomer
    },
    getLogin: state => {
      return state.loginCustomer
    },
    getCompanyNome: state => {
      return state.nomeCompany
    },
    getCompanyEmail: state => {
      return state.emailCompany
    },
    getCompany: state => {
      return state.companyCustomer
    },
    getCompanyKey: state => {
      return state.companyKeyCustomer
    }
  },
  actions: {
    limparCustomer ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('limparCustomer')
        resolve({ status: true })
      })
    }
  },
  mutations: {
    setId (state, n) {
      state.idCustomer = n
      window.localStorage.setItem('idCustomer', n)
    },
    setToken (state, n) {
      state.tokenCustomer = n
      window.localStorage.setItem('tokenCustomer', n)
    },
    setLogin (state, n) {
      state.loginCustomer = n
      window.localStorage.setItem('loginCustomer', n)
    },
    setCompanyNome (state, n) {
      state.nomeCompany = n
      window.localStorage.setItem('nomeCompany', n)
    },
    setCompanyEmail (state, n) {
      state.emailCompany = n
      window.localStorage.setItem('emailCompany', n)
    },
    setCompany (state, n) {
      state.companyCustomer = n
      window.localStorage.setItem('companyCustomer', n)
    },
    setCompanyKey (state, n) {
      state.companyKeyCustomer = n
      window.localStorage.setItem('companyKeyCustomer', n)
    },
    limparCustomer (state) {
      state.idCustomer = null
      state.loginCustomer = null
      state.nomeCompany = null
      state.emailCompany = null
      state.tokenCustomer = null
      state.companyCustomer = null
      state.companyKeyCustomer = null
      window.localStorage.setItem('tokenCustomer', '')
      window.localStorage.setItem('idCustomer', '')
      window.localStorage.setItem('loginCustomer', '')
      window.localStorage.setItem('nomeCompany', '')
      window.localStorage.setItem('emailCompany', '')
      window.localStorage.setItem('companyCustomer', '')
      window.localStorage.setItem('companyKeyCustomer', '')
    }
  }
}
